import i18n from "i18next";
import type { FC } from "react";
import { useNavigate } from "react-router";

import { PrimaryButton } from "../../../../../components/Buttons/components/ActionButton";
import { ResourceName, ResourceVariant } from "../../../../../core/router/config/ResourceName";
import { BASE_PATH, FORM_ACTION } from "../../../../../core/router/types/routerTypes";
import type { NoneOwnProps } from "../../../../../core/types";

export const AddAcquirerPhysicalButton: FC<NoneOwnProps> = () => {
    const navigate = useNavigate();
    const onClick = () => navigate(`${BASE_PATH}/${ResourceName.ACQUIRER}/${ResourceVariant.PHYSICAL}/${FORM_ACTION.CREATE}`);

    return (
        <PrimaryButton name="addPhysical_button" onClick={onClick} disabled={false}>
            {i18n.t("acquirer.add.physical")}
        </PrimaryButton>
    );
};
